import React, { useEffect } from "react";
import { Grid, TextField } from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Alert, Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import { useUnidadesSaudeState } from "./context/unidades-saude-context";
import { useUnidadesSaudeController } from "./context/unidades-saude-controller";
import { UnidadesSaudeTable } from "./unidadesSaudeTable.component";

export function UnidadesSaudePage() {
    const { unidadesSaude, unidadeSaudePagedRequest, loading, error } = useUnidadesSaudeState();
    const { onInit, handleOnChangeTerm, listUnidadesSaude } = useUnidadesSaudeController();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        (async () => {
            await onInit();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        (async () => {
            await listUnidadesSaude({ ...unidadeSaudePagedRequest, page: value - 1 }, true);
        })();
    };

    return (
        <>
            <Breadcrumb
                items={[
                    { label: "Home", href: "/" },
                    { label: "Unidades de Saúde" },
                ]}
            />
            <PageTitle>Unidades de Saúde</PageTitle>
            <Wrapper>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label="Buscar por nome da unidade ou especialidade"
                                    value={unidadeSaudePagedRequest?.term || ''}
                                    onChange={(e: any) => handleOnChangeTerm(e)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <SearchButton onClick={() => (async () => {
                                    await listUnidadesSaude({ ...unidadeSaudePagedRequest, page: 0 }, true);
                                })()}>
                                    <SearchIcon /> Consultar
                                </SearchButton>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <CustomBackdrop open={loading} />
                        {error ? (
                            <Alert severity="error">{error}</Alert>
                        ) : (
                            <UnidadesSaudeTable currentItems={unidadesSaude} />
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={3} justifyContent="center">
                            <Pagination
                                size="large"
                                variant="outlined"
                                shape="rounded"
                                onChange={handlePageClick}
                                count={unidadesSaude?.pageCount}
                                color="primary"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Wrapper>
        </>
    );
}
